// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"f0c55ffc","296":"e3858a26","620":"bf18e318","976":"e3858a26"}[chunkId] + ".chunk.css";
};